export const Res = {
  env: process.env.REACT_APP_ENV || 'local',
  ids: {
    products: {
      TRUE_SIGHT: process.env.REACT_APP_TRUE_SIGHT_ID,
      TRUE_SAGE: process.env.REACT_APP_TRUE_SAGE_ID,
      TRUE_ORACLE: process.env.REACT_APP_TRUE_ORACLE_ID,
    },
  },
  components: {
    maps: {
      MAPBOX_TOKEN:
        process.env.REACT_APP_MAPBOX_API_KEY ||
        'pk.eyJ1IjoiY2hhcmxlc2ZvcnRlcyIsImEiOiJjbG81bmhya2YwMjh1MmtvMzZ4Y3p3NmhmIn0.DRiJTB8yqCfusiZP7n2QSg',
      GOOGLE_TOKEN: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyB7f5e74c1hS56KktrDLOSYMy98j7bRZYg',
    },
  },
  api: {
    gentian: {
      BFF_BASE_URL: process.env.REACT_APP_BFF_BASE_URL,
      STRIPE_MANUAL_RUN_KEY: process.env.REACT_APP_STRIPE_MANUAL_RUN_KEY,
    },
    auth0: {
      DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
      CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
      AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
    },
    datadog: {
      CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    },
    stripe: {
      PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    },
  },
  feature_flags: {
    ENABLE_DASHBOARD: process.env.REACT_APP_FEATURE_DASHBOARD === 'true',
    ENABLE_MY_DASHBOARD: process.env.REACT_APP_FEATURE_MY_DASHBOARD === 'true',
    ENABLE_PROJECTS: process.env.REACT_APP_FEATURE_PROJECTS === 'true',
    ENABLE_VIEW_RESULTS: process.env.REACT_APP_FEATURE_VIEW_RESULTS === 'true',
    ENABLE_RESULT_UPLOAD: process.env.REACT_APP_FEATURE_RESULT_UPLOAD === 'true',
    ENABLE_PRODUCT_MANAGEMENT: process.env.REACT_APP_FEATURE_PRODUCT_MANAGEMENT === 'true',
    ENABLE_ADMIN_PANEL: process.env.REACT_APP_FEATURE_ADMIN_PANEL === 'true',
    ENABLE_PRICING_TOKEN_INFO: process.env.REACT_APP_FEATURE_PRICING_TOKEN_INFO === 'true',
    ENABLE_FAQ: process.env.REACT_APP_FEATURE_FAQ === 'true',
  },
  website_links: {
    TRUE_SIGHT_DETAILS: 'https://gentian.io/true-sight',
    TRUE_SAGE_DETAILS: 'https://gentian.io/true-sage',
    TRUE_ORACLE_DETAILS: 'https://gentian.io/true-oracle',
  },
  product_names: {
    TRUE_SIGHT: 'True Sight',
    TRUE_SAGE: 'True Sage',
    TRUE_ORACLE: 'True Oracle',
    INSTANT_HABMAP: 'Instant Habmap',
  },
};
